export default "__VITE_ASSET__BzDZ5Ci4__"